import { type Agora, agoraOrigin, tasksEnabled } from '../agoras.ts';
import { createAgoraTasksClient, sdkTasks } from './sdk.ts';
import type { TasksSource } from './source.ts';

/**
 * The tasks source for a company, or `null` when its config does not turn
 * Tasks on -- the caller then says `TASKS_OFF_MESSAGE` instead of drawing
 * anything, and no request is ever made to a service that is not there.
 */
export function realTasks(
  agora: Pick<Agora, 'address' | 'tasks'>,
  getAccessToken: () => string,
  fetchImpl?: typeof fetch,
): TasksSource | null {
  if (!tasksEnabled(agora)) return null;
  return sdkTasks(
    createAgoraTasksClient({
      origin: agoraOrigin(agora),
      getAccessToken,
      ...(fetchImpl ? { fetch: fetchImpl } : {}),
    }),
  );
}
